"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentRenderer = void 0;

var _react = require("react");

var _context = require("../../context");

var _renderers = require("../../renderers");

var _utils = require("../../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ComponentRenderer = function ComponentRenderer(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      componentMapOverrides = _ref.componentMap,
      data = _ref.data,
      index = _ref.index,
      parentId = _ref.parentId,
      rest = _objectWithoutProperties(_ref, ["className", "componentMap", "data", "index", "parentId"]);

  try {
    var contentfulContext = (0, _react.useContext)(_context.ContentfulContext);
    var componentMap = Object.assign({}, contentfulContext === null || contentfulContext === void 0 ? void 0 : contentfulContext.componentMap, componentMapOverrides);

    if (Array.isArray(data)) {
      return data.map(function (item, index) {
        return (0, _renderers.renderFromContentfulModel)({
          componentMap: componentMap
        }, _objectSpread(_objectSpread(_objectSpread({}, item), rest), {}, {
          className: className
        }), index, parentId);
      });
    }

    if ((0, _utils.isCollectionShape)(data)) {
      var collectionKey = Object.keys(data)[0];
      return data[collectionKey].items.map(function (item, index) {
        return (0, _renderers.renderFromContentfulModel)({
          componentMap: componentMap
        }, _objectSpread(_objectSpread(_objectSpread({}, item), rest), {}, {
          className: className
        }), index, parentId);
      });
    }

    return (0, _renderers.renderFromContentfulModel)({
      componentMap: componentMap
    }, _objectSpread(_objectSpread(_objectSpread({}, data), rest), {}, {
      className: className
    }), index, parentId);
  } catch (e) {
    console.log('error', e);
    return null;
  }
};

exports.ComponentRenderer = ComponentRenderer;